import React, {useEffect, useState} from 'react';
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import {useRegistrationSteps} from "../../utilities/context/registration-steps/registration-steps-context";
import useAuthCalls from "../../utilities/custom-hooks/auth-calls";
import {doCreatePaymentIntent} from "../../logic/payments";
import CheckoutForm from "./CheckoutForm";
import Loading from "../UI/Loading";
import ErrorMessage from "../UI/ErrorMessage";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const StripePayment = ({...props}) => {

    const {selectedSubscription, user, setAmount} = useRegistrationSteps();

    const [clientSecret, setClientSecret] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorIntent, setErrorIntent] = useState(false);

    const {call} = useAuthCalls();

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            await call(
                () => doCreatePaymentIntent(selectedSubscription.id, user.id),
                (res) => {
                    if (res.client_secret && res.status === "ok") {
                        setClientSecret(res.client_secret);
                    }
                    if (res.amount !== null) {
                        let num = res.amount / 100;
                        num > 0 && setAmount(parseFloat(num).toFixed(2));
                    }
                },
                (error) => {
                    setErrorIntent(true);
                }
            );
            setLoading(false);
        }

        load();
    }, []);

    const options = {
        clientSecret
    }

    return (
        <div>
            {loading
                ? <Loading/>
                : <div>
                    {errorIntent &&
                    <ErrorMessage>Qualcosa è andato storto. Impossibile procedere.</ErrorMessage>
                    }
                    {clientSecret &&
                    <Elements stripe={stripePromise} options={options}>
                        <div className="bg-gray-100 flex flex-col items-center">
                            <CheckoutForm/>
                        </div>
                    </Elements>}
                </div>
            }
        </div>
    );
}

export default StripePayment;
